// extracted by mini-css-extract-plugin
export var active = "_k-8";
export var addWidgetButton = "_k-9";
export var backButton = "_k-1";
export var pageContainer = "_k-2";
export var settingsContent = "_k-0";
export var sideNavContainer = "_k-6";
export var sideNavLink = "_k-7";
export var widgetContainer = "_k-5";
export var widgetSubsectionItem = "_k-3";
export var widgetSubsectionItemContent = "_k-4";